import { client, getCookie } from "src/utils";
import { base } from "./base";

export * from "./base";
export * from "./hooks";

const GLOBALS = {
  API: {
    ...window.GLOBALS.API
  }
}

const notifications = {
  registerUser: (params = {}, opts = {}) => base.post(`${GLOBALS.API.NOTIFICATIONS}/user`, params, opts),
  reportEvent: (params = {}, opts = {}) => base.post(`${GLOBALS.API.NOTIFICATIONS}/notification/report`, params, opts)
};

window.visitorId = getCookie("visitorId");
function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// The API client
export default {
  ...base,
  notifications,

  getContent: (params = {}) => base.get(GLOBALS.API.CONTENT, params),

  getNews: ({ category = "top", feedStyle = "small", limit = 5, offset = 0, ...rest } = {}) =>
    base.get(GLOBALS.API.NEWS, { ...rest, category, feedStyle, limit, offset, userID: window.visitorId }, { credentials: "include" }),

  getLocationAutocomplete: (params = {}) => base.get(GLOBALS.API.LOCATION_AUTOCOMPLETE, params),

  getReading: ({ brief = "yes", ...rest } = {}) => base.get(GLOBALS.API.HOROSCOPE, { ...rest, brief, userID: window.visitorId }),

  getApps: ({ androidIDSupported = false, limit = 12, os = client.os(), userAgent = client.userAgent(), ...rest } = {}) =>
    base.get(GLOBALS.API.APP_OFFERS, { ...rest, androidIDSupported, limit, os, userAgent, userID: window.visitorId }, { credentials: "include" }),

  getTiles: (params = {}) => base.get(GLOBALS.API.FEATURED_AD_TILES, params, { credentials: "include" }),

  getLocalSearch: (params = {}) =>
    base.get(GLOBALS.API.LOCAL, {
      ...params,
      referrer: GLOBALS.ENV == "development" ? "klint.staging.airfind.com" : window.location.hostname,
      userID: window.visitorId
    }),

  getSearch: ({ searchTerm: search_term, ...rest } = {}) =>
    base.get(GLOBALS.API.SEARCH, { ...rest, search_term, userID: window.visitorId }, { credentials: "include" }),
  
  getSponsoredSearch: ({ searchTerm: search_term, ...rest } = {}) =>
    base.get(GLOBALS.API.SPONSORED_SEARCH, { ...rest, search_term, userID: window.visitorId }, { credentials: "include" }),

  getSearchAutocomplete: (params = {}) => base.get(GLOBALS.API.SEARCH_AUTOCOMPLETE, params),

  searchCallback: (params = {}) =>
    base.post(GLOBALS.API.SEARCH_CALLBACK, {
      searchQuery: {
        ...params,
        uid: uuidv4(),
        visitorId: params.visitorId || window.visitorId,
        host: location.host,
        referer: location.href,
        userAgent: navigator.userAgent
      }
    }),

  getBingTrendingTermsClient: (params = {}) => {
    const query = {
      ext: {
        appid: "677BD45D7CB8DC5001A8CCEE3CF20A3FB1AD1D44",
        pagetype: "default_" + (params.bingTrendingTermsQuantity || params.searchBarBingTrendingTerms)
      },
      id: window.visitorId || uuidv4(),
      imp: [
        {
          id: uuidv4()
        }
      ],
      site: {
        cat: ["trendingrecs"],
        content: {},
        keywords: "news, technology",
        publisher: {
          ext: {
            adUnitId: 374157,
            formcode: params.formCode,
            partnercode: "AFBT",
            propertyId: 361355,
            tracingtag: "tracfone_"
          },
          id: "25135876",
          name: "airfind"
        }
      }
    };
    const clientUrlParams = {
      appid: "677BD45D7CB8DC5001A8CCEE3CF20A3FB1AD1D44",
      q: encodeURIComponent(JSON.stringify(query))
      // referer: encodeURIComponent("http://klint.staging.airfind.com"),
      // referrer: encodeURIComponent("http://klint.staging.airfind.com"),
    };
    return base.get(GLOBALS.API.TRENDING_TERMS_CLIENT, clientUrlParams);
  },
  getBingTrendingTerms: (params = {}) => base.get(GLOBALS.API.TRENDING_TERMS, params),

  geolocate: (params = {}) => base.get(GLOBALS.API.GEOCODE, params),

  geolocateReverse: (params = {}) => base.get(GLOBALS.API.GEOCODE_REVERSE, params),

  getOffers: (params = {}) => base.get(GLOBALS.API.OFFERS, { ...params, userId: window.visitorId }),

  pushDataToBQ: (data = {}, type) => {
    try {
      base.post(`${GLOBALS.API.EVENT_TRACKER_URI}/bq/${type}/v1`, data)
    } catch(error){
      console.log(error)
    }
  },

  getContentAiArticles: (params = {}) => base.get(`${GLOBALS.API.CONTENT_AI}/query`, params),

  getContentAiArticle: (params = {}) => base.get(`${GLOBALS.API.CONTENT_AI}`, params),
  
  getRecaptchaScore: (params = {}) => base.get(`${GLOBALS.API.EVENT_TRACKER_URI}/stats/recaptcha/assessment/v1`, params),

  getSitemapCategories: (params = {}) => base.get(`${GLOBALS.API.CONTENT_AI}/sitemap/categories`, params),

  getSitemap: (params = {}) => base.get(`${GLOBALS.API.CONTENT_AI}/sitemap`, params),
};
